/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResultStringDto } from '../../models/result-string-dto';

export interface UpdateUserAvatar$Params {
  userId: number;
      body: {
}
}

export function updateUserAvatar(http: HttpClient, rootUrl: string, params: UpdateUserAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
  const rb = new RequestBuilder(rootUrl, updateUserAvatar.PATH, 'post');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResultStringDto>;
    })
  );
}

updateUserAvatar.PATH = '/api/avatar/user/{userId}';
